



























import Vue from 'vue';
import Icon from '../Icon';

export default Vue.extend({
  components: { Icon },
  props: {
    imgSrc: {
      type: String,
      default: '',
    },
    background: {
      type: Boolean,
      default: false,
    },
    iconSrc: {
      type: String,
      default: '',
    },
    videoIcon: {
      type: Boolean,
      default: false,
    },
    backgroundSrc: {
      type: String,
      default: '',
    },
    maskUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    emitPlayVideo() {
      this.$emit('playVideo');
    },
  },
});
